module.exports = {
    CREATEACTAS:'Crear Actas',
    CREATEENTRY:'Crear Ingresos de Ítems',
    CREATEOT: 'Crear Orden de trabajo',
    CREATEUSER:'Crear Usuario',
    CREATECLIENT:'Crear Cliente',
    CREATEITEM:'Crear Ítem',
    CREATEMAG:'Crear Magnitud',
    CREATEROLE:'Crear Roles', 
    APROVEEDITEM:'Aprobar Ítems',
    CALIBRATE:'Calibrar Ítems',
    PROGRAMOT:'Porgramar Ordenes de trabajo',
    VIEWENTRY:'Ver ingresos',
    VIEWOT:'Ver ordenes de trabajo',
    VIEWCALENDAR:'Ver calendario',
    VIEWCLIENT:'Ver lista de clientes',
    VIEWROLE:'Ver roles',
    TECNICHAL:'Gestion Tecnica',
    CREATEPROGRAMACION:'Realizar programaciones',
    VIEWPROGRAMACION:'Ver programaciones',
    VIEWALLPROGRAMACION:'Ver todas las programaciones',
    COMERCIAL:'Area Comercial',
    CREATEREGISTER:'Crear Registro',
    FINANCIAL:'Area Financiera',
    VIEWREQUISICIONES:'Ver Requisiciones',
    CREATEREQUISICION:'Crear Requisición',
    APPROVEREQUISICION:'Aprobar Requisición',
    EDITAR_REQUISICION:'Editar Requisición',
    SELECCIONAR_GANADOR_REQUISICION:'Seleccionar Ganador Requisición',
    VIEWPROVEEDORES:'Ver Proveedores',
    CREATEPROVEEDOR:'Crear Proveedor',
    EMITIR_OC_REQUISICION:'Emitir Orden de Compra Requisición',
    APROBAR_OC_REQUISICION:'Aprobar Orden de Compra Requisición',
    GESTIONAR_CERTS_REQUISICION:'Gestionar Certificados Requisición',
    VIEW_PROPUESTAS:'Ver Propuestas',
    CREATE_PROPUESTAS:'Crear Propuestas',
    EDIT_PROPUESTAS:'Editar Propuestas',
    SEND_PROPUESTAS:'Enviar Propuestas',
    DELETE_PROPUESTAS:'Eliminar Propuestas',
    SYNC_PROPUESTAS:'Sincronizar Propuestas',
    VIEW_DASHBOARD_PROPUESTAS:'Ver Dashboard Propuestas',
    MANAGE_PLANTILLA_PROPUESTAS:'Administrar Plantilla Propuestas',
    //permisos para el modulo de finanzas, que incluye la gestion de bolsillos y gastos 
    GESTION_ENTREGAS:'Gestionar Entregas',
    GESTION_ERRORES:'Gestionar Errores',
    CONFIGURACION_CONTABLE:'Configurar Contabilidad',
    DASHBOARD_FINANCIERO:'Informe Financiero',
    COMPROBANTES_CONTABLES:'Gestionar Comprobantes Contables',
    APPROVE_RELACIONES:'Aprobar Relaciones',
    REVISION_RELACIONES:'Revisar Relaciones',
    GESTION_BOLSILLOS:'Gestionar Bolsillos',
    // Permiso para cambiar la plantilla de un lote ya confirmado
    // (spec lotes-tabs-refresh-plantilla / lotes-cambio-plantilla-post-confirmacion).
    // Enforcement solo en frontend (backend no valida rol/permiso para este endpoint).
    CAMBIAR_PLANTILLA_CONFIRMADA:'Cambiar plantilla confirmada',
    // Permite forzar finalización de un lote aunque haya sesiones incompletas
    // (spec lotes-finalizacion-hoja-trabajo-avance D18). Enforcement UI + audit backend.
    FORZAR_FINALIZAR_LOTE:'Forzar finalizacion de lote',
    // Habilita acciones Finalizar/Aprobar/Entregar en los tabs de seguimiento
    // (/otlista/total) para desatrasar indicadores. Las transiciones NO
    // generan hojas de trabajo ni evidencias. Enforcement UI + backend.
    ACCIONES_SEGUIMIENTO_EQUIPO:'Acciones Seguimiento Equipo',
  }